export interface DashboardPaths {
  LandingPage: string,
}

export const dashboardPaths: DashboardPaths = {
  LandingPage: '/dashboard',
};
